import { render, staticRenderFns } from "./KSRPhoneVerification.vue?vue&type=template&id=6914c772&scoped=true&"
import script from "./KSRPhoneVerification.vue?vue&type=script&lang=js&"
export * from "./KSRPhoneVerification.vue?vue&type=script&lang=js&"
import style0 from "./KSRPhoneVerification.vue?vue&type=style&index=0&id=6914c772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6914c772",
  null
  
)

export default component.exports